export default __webpack_public_path__ + "static/media/ic_fail.118310e7.svg";